<div class="m2m-tokens">
  <h1 class="m2m-tokens__title">M2M токени</h1>

  <mat-card class="m2m-tokens__card">
    <mat-card-header>
      <mat-card-title>Генерація токена для candidate/apply</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p class="m2m-tokens__hint">
        Токен передається інтеграції як <code>Authorization: Bearer &lt;token&gt;</code> у запитах
        <code>POST /candidate/{{ sourceControl.value || ':source' }}/apply</code>.
      </p>

      <div class="m2m-tokens__inputs">
        <mat-form-field appearance="outline" class="m2m-tokens__source">
          <mat-label>Джерело</mat-label>
          <mat-select [formControl]="sourceControl">
            @for (source of sources(); track source.source) {
              <mat-option [value]="source.source">
                {{ source.source }} — заявки в source #{{ source.sourceId }}
              </mat-option>
            }
          </mat-select>
          @if (sourcesLoading()) {
            <mat-hint>Завантаження джерел...</mat-hint>
          } @else if (!sources().length) {
            <mat-hint>Жодного джерела не дозволено в allowedExternalJobSource.</mat-hint>
          }
        </mat-form-field>

        <button
          mat-raised-button
          color="primary"
          (click)="generateToken()"
          [disabled]="!sourceControl.value || generating()"
        >
          {{ generating() ? 'Генерація...' : 'Згенерувати' }}
        </button>
      </div>

      @if (generatedToken(); as token) {
        <mat-form-field appearance="outline" class="m2m-tokens__result">
          <mat-label>Токен</mat-label>
          <textarea matInput readonly rows="3" [value]="token"></textarea>
          <mat-hint>Зберігається лише тут — токен не записується в базу, згенеруйте новий за потреби.</mat-hint>
        </mat-form-field>
      }
    </mat-card-content>
  </mat-card>

  <mat-card class="m2m-tokens__card">
    <mat-card-header>
      <mat-card-title>Перевірка токена</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p class="m2m-tokens__hint">Показує, яке джерело зашите у вже виданий токен і чи пропустить його гард.</p>

      <mat-form-field appearance="outline" class="m2m-tokens__result">
        <mat-label>Токен</mat-label>
        <textarea matInput rows="3" [formControl]="tokenControl" placeholder="7f0c….a91b…"></textarea>
      </mat-form-field>

      <div class="m2m-tokens__inputs">
        <button
          mat-stroked-button
          color="primary"
          (click)="verifyToken()"
          [disabled]="!tokenControl.value || verifying()"
        >
          {{ verifying() ? 'Перевірка...' : 'Перевірити' }}
        </button>
      </div>

      @if (verification(); as result) {
        <div class="m2m-tokens__verdict" [class.m2m-tokens__verdict--invalid]="!result.valid">
          <mat-icon>{{ result.valid ? 'check_circle' : 'cancel' }}</mat-icon>
          <div>
            @if (result.valid) {
              <strong>Токен дійсний</strong>
              <p>Джерело: {{ result.source }}</p>
            } @else {
              <strong>Токен недійсний</strong>
              <p>{{ result.reason }}</p>
              @if (result.source) {
                <p>Джерело в токені: {{ result.source }}</p>
              }
            }
          </div>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
